import './bootstrap';

// Init code
Bolt.once('unload', (event) => {
    document.head.querySelectorAll('style').forEach((style) => {
        if (!style.hasAttribute('bolt-pin') && style.innerHTML.includes('url(/cf-fonts/')) {
            style.removeAttribute('bolt-transient');
            style.setAttribute('bolt-pin', '');
        }
    });
});

Bolt.on('unload', (event) => {
    document.querySelectorAll('.modal').forEach((element) => bootstrap.Modal.getInstance(element)?.hide());

    ['tooltip', 'popover'].forEach((type) =>
        document
            .querySelectorAll(`[aria-describedby^="${type}"]`)
            .forEach((element) => bootstrap[type.charAt(0).toUpperCase() + type.slice(1)].getInstance(element)?.hide())
    );
});

Bolt.setTargetSelectors('#app-container');
Bolt.start();
